import { websiteEnv } from './website-env';

// us
let ga4Id = 'G-84XJ7MW63B';
let gtmId = 'GTM-P565JQB';
let facebookId = '1368027759939536';

if (websiteEnv.isUnitedKingdom) {
  ga4Id = 'G-302ZHYJ0BJ';
  gtmId = 'GTM-N2SZWG9';
  facebookId = '707382621645900';
} else if (websiteEnv.isCanada) {
  ga4Id = 'G-EN92R4P8BL';
  gtmId = 'GTM-MT8DSFNJ';
  facebookId = '1186506776025744';
}

export const siteConfigIds = {
  ga4Id,
  gtmId,
  facebookId,
};
